<template>
  <div class="ar-marker-instructions-outer">
    <div class="ar-marker-instructions">
      <div class="button-container"><el-button class="cancel-btn" @click="$emit('cancel')">CANCEL</el-button></div>
      <div class="centered-stuff">
        <h1 class="title">You will have to use your phone’s camera and print out a marker.</h1>
        <img class="marker-img" src="/static/img/marker.png"></img>
        <el-button class="done-btn" @click="$emit('update:shown', false)">LET’S START</el-button>
        <h2>BY THE WAY</h2>
        <p>Take this at whole different level, download our AR native app!</p>
        <div class="app-download-btn">
          <a href="https://play.google.com/store/apps/details?id=it.accurat.BuildingHopes" v-if="$root.platform.android" target="_blank"><img src="../assets/img/google-play.png" /></a>
          <a href="https://itunes.apple.com/app/building-hopes/id1424884572?ls=1&mt=8" v-if="$root.platform.ios" target="_blank"><img src="../assets/img/app-store.png" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElButton from 'element-ui/packages/button'

export default {
  name: 'ARMarkerInstructions',
  components: {
    ElButton
  },
  data: function () {
    return {
      markerLink: 'goo.gl/hope19537',
      markerShareTitle: 'Open this link!',
      supportsShareApi: navigator.share !== undefined && typeof navigator.share === 'function'
    }
  },
  props: {
    shown: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    shareApiCall: function () {
      navigator.share({title: 'Google Hope', text: this.markerShareTitle, url: this.markerLink})
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';



$inter-block-margin: 25px;

.share-to-friend {
  margin-top: $inter-block-margin;
}

.share-to-friend-inner {
  border-bottom: 2px solid $c-light-gray;
}

.ar-marker-instructions-outer {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: $c-light-brown;
  z-index: 9999;
  overflow-y: scroll;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  pointer-events: all;
}

.ar-marker-instructions {
  width: 100%;
  height: 100%;
  display: table;
}

.centered-stuff {
  padding: 0 20%;
  display: table-cell;
  vertical-align: middle;
  // horizontal-align: center;
}

.marker-img {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: $inter-block-margin;
}

.button-container {
  text-align: left;
  display: table-row;
  height: 70px;
}

.link {
  display: block;
  color: $c-gray;
}

h1 {
  margin-bottom: $inter-block-margin;
}
h2 {
  color: $c-gray;
  margin-bottom: $inter-block-margin;
}

p {
  margin: 0;
  margin-bottom: $inter-block-margin;
}

.done-btn {
  margin-bottom: $inter-block-margin;
}

.app-download-btn {
  width: 100%;

  a,
  img {
    width: 100%;
    height: auto;
  }
}


</style>



// WEBPACK FOOTER //
// src/organisms/ARMarkerInstructions.vue